import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query AnswerTemplates($id: Int!) {
  answerTemplate(id: $id) {
    id
    text
    value
    markers{
      id
      name
    }
  }
}`;

function getAnswerTemplate({ id }) {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
    variables: { id: parseInt(id, 10) },
  }).then((data) => data.data.answerTemplate);
}

export default getAnswerTemplate;
